import { ListResult } from "@/common/models";
import { formatInput, gql2 } from "@/gql/lib";
import {
  ActionEnum,
  CoordinateInputTier1Tier2,
  CountOrderByEnum,
  Direction,
  QueryTier1countArgs,
} from "@/gql/types";

export const get_entities = gql2<
  {
    coordinate: CoordinateInputTier1Tier2;
    cursor: string;
  },
  ListResult<any>
>("entities.get", ({ coordinate, cursor = "" }, { allInfoTypes }) => {
  const q: QueryTier1countArgs = {
    params: {
      coordinate,
      cursor,
      action: ActionEnum.List,
      direction: Direction.Descend,
      orderBy: CountOrderByEnum.Count,
    },
  };
  return {
    query: `{
        #EXPORT
         tier2count(params:${formatInput(q.params)}){
            count
            startDate
            endDate
            cursor
            y{value}
            x{value}
          }
          #EXPORT_END
        }`,
    mapper: (res) => {
      const { tier2count } = res;
      return {
        cursor: tier2count.length > 0 ? tier2count[0].cursor : "",
        objects: tier2count
          .filter((d: any) => allInfoTypes[d.y.value])
          .map((d: any) => {
            const label_id = d.y.value;
            const label = allInfoTypes[label_id];
            return {
              id: label_id,
              code: label.code,
              name: label.labelName,
              startDate: d.startDate,
              endDate: d.endDate,
              count: d.count,
            };
          }),
      };
    },
  };
});
